import { NgModule } from '@angular/core';
import { UpgradeNg1Helpers } from './../../helpers/upgrade/upgrade-ng1.helper';

@NgModule({
  providers: [
    UpgradeNg1Helpers.upgradeProvider('$http'),
    UpgradeNg1Helpers.upgradeProvider('SpinnerModal'),
    UpgradeNg1Helpers.upgradeProvider('Title'),
    UpgradeNg1Helpers.upgradeProvider('$state'),
    UpgradeNg1Helpers.upgradeProvider('$stateParams'),
    UpgradeNg1Helpers.upgradeProvider('$stateProvider'),
    UpgradeNg1Helpers.upgradeProvider('$timeout'),
    UpgradeNg1Helpers.upgradeProvider('Idle'),
    UpgradeNg1Helpers.upgradeProvider('$location'),
    UpgradeNg1Helpers.upgradeProvider('$window'),
    UpgradeNg1Helpers.upgradeProvider('NavService'),
    UpgradeNg1Helpers.upgradeProvider('CachedObject'),
    UpgradeNg1Helpers.upgradeProvider('$scope'),
    UpgradeNg1Helpers.upgradeProvider('SDCStore'),
    UpgradeNg1Helpers.upgradeProvider('User'),
    UpgradeNg1Helpers.upgradeProvider('StudentReportModal'),
    UpgradeNg1Helpers.upgradeProvider('NoteModal'),
    UpgradeNg1Helpers.upgradeProvider('StudentSupportModal'),
    UpgradeNg1Helpers.upgradeProvider('ImTool'),
    UpgradeNg1Helpers.upgradeProvider('Student'),
    UpgradeNg1Helpers.upgradeProvider('Rollbar'),
    UpgradeNg1Helpers.upgradeProvider('ImSupport'),
    UpgradeNg1Helpers.upgradeProvider('ImStudentSupport'),
    UpgradeNg1Helpers.upgradeProvider('$mdToast'),
    UpgradeNg1Helpers.upgradeProvider('$rootScope'),
    UpgradeNg1Helpers.upgradeProvider('StudentSupport'),
    UpgradeNg1Helpers.upgradeProvider('$interval'),
    UpgradeNg1Helpers.upgradeProvider('ErrorModal'),
    UpgradeNg1Helpers.upgradeProvider('SchoolToolbarService'),
    UpgradeNg1Helpers.upgradeProvider('SorterColumn'),
    UpgradeNg1Helpers.upgradeProvider('sdcActions'),
    UpgradeNg1Helpers.upgradeProvider('Support'),
    UpgradeNg1Helpers.upgradeProvider('BackgroundJobSpinner'),
    UpgradeNg1Helpers.upgradeProvider('PlannedDiplomaOptionsModal'),
    UpgradeNg1Helpers.upgradeProvider('ImStudentGradPlanning'),
    UpgradeNg1Helpers.upgradeProvider('StudentFetchMssgsService'),
    UpgradeNg1Helpers.upgradeProvider('StudentFetchUnzipService'),
    UpgradeNg1Helpers.upgradeProvider('GapPlan'),
    UpgradeNg1Helpers.upgradeProvider('Report'),
    UpgradeNg1Helpers.upgradeProvider('PusherService'),
    UpgradeNg1Helpers.upgradeProvider('FileSaver'),
    UpgradeNg1Helpers.upgradeProvider('Blob'),
    UpgradeNg1Helpers.upgradeProvider('StudentSet'),
    UpgradeNg1Helpers.upgradeProvider('$q'),
    UpgradeNg1Helpers.upgradeProvider('ImStudent'),
  ],
})
export class UpgradedServicesModule {
  //
}
